import { BannerBlock } from "../BannerBlock";

export const CallToActionBlock = props => (
  // For the time being, the Call to Action block is identical to the Banner block
  <BannerBlock {...props} />
);

CallToActionBlock.propTypes = {};
